import React, { useState } from "react";
import { useRouter } from "next/router";
import { useQuery } from "@apollo/client";
import { dehydrateApolloClient, initApolloClient } from "@/lib/apolloClient";
import { useAuthState } from "@/contexts/auth/auth.provider";
import { InitialResolver } from "@/lib/use.middlewares";
import { GET_MY_PACKAGES, GET_PACKAGES } from "@/graphql/queries/payment";
import DeveloperCard from "@/components/payment-cards/developerCard";
import styles from "./.module.scss";
import { Modal, Radio } from "@aqar-app/react-ui";
import { WarningAlert } from "@/components/login-alert";

const packagesOptions = [
  { label: "باقة  50 إعلان", value: "0", className: styles.radioBtn },
  { label: "باقة  150 إعلان", value: "1", className: styles.radioBtn },
  { label: "باقة  250 إعلان", value: "2", className: styles.radioBtn },
];

function RedPackagesPlans() {
  const router = useRouter();
  const { token } = useAuthState();
  const [activePkgIndex, setActivePkgIndex] = useState(0);
  const { data } = useQuery(token ? GET_MY_PACKAGES : GET_PACKAGES, {
    context: { token },
    variables: {
      include_projects_packages: true,
    },
    onError: (err) => {
      Modal.open(
        <WarningAlert text={err.message} onOk={() => router.push(`/`)} />,
      )();
    },
  });

  const plans = (
    token ? data?.Offices?.Package?.getMyPackages : data?.Offices?.packages
  )?.filter((plan) => plan.sub_pkg_type === 48);

  return (
    <div className={styles.servicesCards}>
      <h1 className={styles.title}>
        الرجاء اختيار الخدمة التي ترغب بدفع رسومها
      </h1>
      <div className={styles.radioBtnWrapper}>
        <Radio
          value={activePkgIndex}
          onChange={(e, raw) => {
            setActivePkgIndex(raw.value);
          }}
          button
        >
          {packagesOptions.map((opt) => (
            <Radio.Option label={opt.label} value={opt.value} raw={opt} />
          ))}
        </Radio>
      </div>
      <div className={`${styles.cardsContainer} ${styles.isPackages}`}>
        {plans?.map((plan, index) => (
          <DeveloperCard
            plan={plan}
            active={activePkgIndex === index}
            index={index}
          />
        ))}
      </div>
    </div>
  );
}

RedPackagesPlans.getInitialProps = InitialResolver(async (ctx) => {
  const { token } = ctx.authState;
  const apolloClient = initApolloClient();

  await apolloClient.query({
    query: token ? GET_MY_PACKAGES : GET_PACKAGES,
    context: { token },
    variables: {
      include_projects_packages: true,
    },
  });
  return dehydrateApolloClient(apolloClient, {});
});

export default RedPackagesPlans;
